import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { Component, defaultValue, Schema, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";

@Component("HpRegenScaler")
export class HpRegenScalerSchema extends Schema {
  @type("number")
  @defaultValue(0)
  regenScale: number;
}

class HpRegenScalerSystem implements System {
  schema = HpRegenScalerSchema;
  type = "HpRegenScaler";
  dependencies = ["Child"];
  init(entity: number, gameModel: GameModel) {
    if (gameModel.hasComponent(entity, ChildSchema)) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "HpRegenScaler")) {
        gameModel.addComponent(parent, HpRegenScalerSchema);
      }
      gameModel.getTypedUnsafe(parent, HpRegenScalerSchema).regenScale += gameModel.getTypedUnsafe(
        entity,
        HpRegenScalerSchema
      ).regenScale;
    }
  }
}
registerSystem(HpRegenScalerSystem);
